import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import BankInterfaceMonitoringMaintenanceCont from "presentation/view/container/BankInterfaceMonitoring/BankInterfaceMonitoringContMain";

CommonEntrypoint(<BankInterfaceMonitoringMaintenanceCont/>)